import React, { Component } from "react";
import Table from "../components/Table";
import { connect } from "react-redux";
import { OrganizationInfoDialog } from "../dialogs/OrganizationInfoDialog";
import AddOrganization from "../containers/AddOrganization";
import EditOrganization from "../containers/EditOrganization";
import { map } from "../utils/map";
import { ORGANIZATIONS, createInfoUrl } from "../utils/routes";

export class organizationsPage extends Component {
  state = {
    showAddDialog: false,
    showEditDialog: false
  };

  headers = [
    { id: 0, title: "Name", sortable: true },
    { id: 1, title: "Number of Devices", sortable: true }
  ];

  extractData = () => {
    const { organizations } = this.props;

    let data = [];
    for (let key in organizations) {
      let { name } = organizations[key];
      data.push({
        key,
        row: [name, this.extractAmauntOfDevicesInOrg(key)],
        searching: [name]
      });
    }
    return data;
  };

  extractAmauntOfDevicesInOrg = organizationId => {
    const { devices } = this.props;
    let numDevices = 0;

    map(devices, ({ organizationRef }) => {
      if (organizationRef && organizationRef.id == organizationId) {
        numDevices++;
      }
    });
    return numDevices;
  };

  render() {
    const {showAddDialog, showEditDialog} = this.state;
    const { organizations, loading } = this.props;

    const { history, match } = this.props;
    const { selectedKey } = match.params;
    
    return (
      <div>
        {showAddDialog && (
          <AddOrganization
            onClose={() => this.setState({ showAddDialog: false })}
          />
        )}

        {selectedKey && !showEditDialog && organizations[selectedKey] && (
          <OrganizationInfoDialog
            onClose={() => history.push(ORGANIZATIONS)}
            onEdit={() =>  this.setState({ showEditDialog: true })}
            name={organizations[selectedKey].name}
            amauntOfDevices={this.extractAmauntOfDevicesInOrg(selectedKey)}
            loading={loading}
          />
        )}

        {showEditDialog && organizations[selectedKey] && (
          <EditOrganization
            selectedKey={selectedKey}
            onClose={() => this.setState({ showEditDialog: false })}
          />
        )}

        <Table
          title="Organizations"
          headers={this.headers}
          rows={this.extractData()}
          onRowClick={key => history.push(createInfoUrl(ORGANIZATIONS,key))}
          addNewTitle="New Organization"
          onAddNewClick={() => this.setState({ showAddDialog: true })}
          loading={loading}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  organizations: state.data.organizations,
  devices: state.data.devices
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(organizationsPage);
